import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SwapArrowIcon } from '~/components/icons'
import { TradeDirection } from '~/components/Exchange/types'
import { ExchangeTab } from '~/components/ExchangeTab'
import { ExchangeBox } from '~/components/Layout'
import { useModalOpened, useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import { useDirectionChange, useInitTokenPairByRouter } from '../../hooks'
import Activity from '~/components/Activity'
import DateSelect from '../DateSelect'
import MaxButton from '../MaxButton'
import RateInput from '../RateInput'
import TokenInput from '../TokenInput'
import TradeButton from '../TradeButton'
import ExpandedRateArea from '../ExpandedRateArea'
import MarketRateRow from '../MarketRateRow'
import OrderWarning from '../OrderWarning'
import { ArrowButton, Row, StyledLimitSwap, Divider } from './styled'
import { useAccount } from 'wagmi'
import { useIsDisableTrade } from '~/state/dex/hooks'

const LimitSwap: React.FC = () => {
  const { t } = useTranslation()
  const isPreviewOpen = useModalOpened(ApplicationModal.LIMIT_ORDER_PREVIEW)

  const isWETHOpen = useModalOpened(ApplicationModal.WETH_WRAP)
  const hide = isPreviewOpen || isWETHOpen

  const toggleIpBlockedModal = useModalToggle(ApplicationModal.IP_BLOCKED)
  const onDirectionChange = useDirectionChange()
  const { address: account } = useAccount()
  const [wrapETHTipVisible, setWrapETHTipVisible] = useState(false)
  const isDisableTrade = useIsDisableTrade()

  useInitTokenPairByRouter()

  useEffect(() => {
    if (isDisableTrade) {
      toggleIpBlockedModal()
    }
  }, [isDisableTrade])

  return (
    <ExchangeBox className={`limitswap ${hide && 'hide'}`}>
      <Activity />
      <StyledLimitSwap>
        <ExchangeTab tipVisible={wrapETHTipVisible} />
        <MaxButton />
        <TokenInput
          direction={TradeDirection.Input}
          groupStyle={{ marginTop: account ? 0 : 29, marginBottom: 16 }}
        />
        <Row>
          <RateInput />
          <DateSelect />
        </Row>
        <MarketRateRow />
        <ArrowButton onClick={onDirectionChange}>
          <SwapArrowIcon />
        </ArrowButton>
        <TokenInput
          direction={TradeDirection.Output}
          groupStyle={{ marginTop: 18, marginBottom: 0 }}
        />
        <Divider />
        <ExpandedRateArea />
        <OrderWarning />
        <TradeButton
          text={t('preview_order')}
          setTipVisible={setWrapETHTipVisible}
        />
      </StyledLimitSwap>
    </ExchangeBox>
  )
}

export default LimitSwap
